export default {
    USER_NOT_LOGGED_IN : -1,
    USER_LOGGED_IN: 0,
    ADMINISTRATOR: 1,
    NEED_TO_BE_LOGGED_ID: [0, 1],
    NEED_TO_BE_ADMINISTRADOR: [1],
    getNeedToBe: (role) => {
        const needs = {
            0: [0,1],
            1: [1]
        };
        return needs[role];
    }
};